import { Outlet } from 'react-router';
import { ThemeProvider } from 'styled-components';

import { ErrorBoundary } from '#/containers/ErrorBoundary';
import { ModalRoot } from '#/containers/Modal/ModalRoot';
import { TabContextProvider } from '#/containers/TabContext';
import { ToastsContainer } from '#/containers/ToastsContainer';
import { TmpStorageContextProvider } from '#/contexts/TmpStorageContext';
import { SearchContextProvider } from '#/modules/search/contexts/SearchContext';
import { themeContextValue } from '#/theme/theme';

import { GlobalHandlers } from './global-handlers/GlobalHandlers';

export function App() {
  return (
    <ThemeProvider theme={themeContextValue}>
      <ErrorBoundary>
        <SearchContextProvider>
          <GlobalHandlers />
          <TmpStorageContextProvider>
            <TabContextProvider>
              <ModalRoot />
              <ToastsContainer />
              <Outlet />
            </TabContextProvider>
          </TmpStorageContextProvider>
        </SearchContextProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
}
